export default "__VITE_ASSET__DkP6yWSY__"